import { lowerUserAgent } from "./shared.js";
const jsdom = /jsdom|happydom/.test(lowerUserAgent);
export {
  jsdom
};
//# sourceMappingURL=env.js.map
